import { createRouter, createWebHistory } from "vue-router";
import Home from "./views/Home.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/video/:id/:slug",
    name: "video",
    component: () =>
      import(/* webpackChunkName: "video" */ "./views/PlayVideo.vue"),
    props: true,
  },
  {
    path: "/a-propos",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "./views/About.vue"),
    props: true,
  },
  {
    // “catch-all” en vue-router 4 (remplace le `path: '*'`)
    path: "/:pathMatch(.*)*",
    name: "notfound",
    component: () =>
      import(/* webpackChunkName: "notfound" */ "./views/NotFound.vue"),
    props: true,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
